const Divider = () => {
  return (
    <div className="divider theme-color-bg">
      
    </div>
  )
}

export default Divider
